var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, State, CustomElement, Watch, Event, COMPONENT_STATE, Interceptor, classMap, html, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Button.style';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
const isTouch = window.navigator.maxTouchPoints > 0 || !!('ontouchstart' in window);
/**
 * A `davinci-button` which can be activated using mouse click, space- or enter-key. It can also be used as a toggle button.
 * Style can be influenced using the type attribute. If toggle is set, it can be used with a `davinci-toggle-group`.
 *
 * @example
 * ```html
 * <davinci-button onclick="console.log('clicked')">Click me</davinci-button>
 * ```
 * @slot { * } content inside the button
 */

export let Button = (_dec = Component({
  tag: 'davinci-button',
  style: [style],
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = State(), _dec21 = Reflect.metadata("design:type", Boolean), _dec22 = Event('change'), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Event('submit'), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Interceptor('type'), _dec27 = Reflect.metadata("design:paramtypes", [String, String]), _dec28 = Watch('disabled'), _dec29 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = class Button extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "selected", _descriptor, this);

    _initializerDefineProperty(this, "type", _descriptor2, this);

    _initializerDefineProperty(this, "icon", _descriptor3, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor4, this);

    _initializerDefineProperty(this, "iconPosition", _descriptor5, this);

    _initializerDefineProperty(this, "toggle", _descriptor6, this);

    _initializerDefineProperty(this, "name", _descriptor7, this);

    _initializerDefineProperty(this, "value", _descriptor8, this);

    _initializerDefineProperty(this, "disabled", _descriptor9, this);

    _initializerDefineProperty(this, "isempty", _descriptor10, this);

    _initializerDefineProperty(this, "changeEvent", _descriptor11, this);

    _initializerDefineProperty(this, "submitEvent", _descriptor12, this);

    _defineProperty(this, "_mutationObserver", new MutationObserver(() => this.slotchanged()));

    _defineProperty(this, "_mutationObeserverParent", this);

    _defineProperty(this, "slotchanged", () => {
      // workaround since we can not target text nodes in ::slotted to set or reset padding and host(:empty) does not work on ShadyCSS
      if (this._getIsEmpty()) {
        this.isempty = true;
        this.classList.add('empty');
      } else {
        this.isempty = false;
        this.classList.remove('empty');
      }
    });

    _defineProperty(this, "_onKeydownEvent", evt => {
      if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
        evt.preventDefault();
      }
    });

    _defineProperty(this, "_onKeyupEvent", evt => {
      if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
        // browsers sends different keys
        this.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: false
        }));
      }
    });

    _defineProperty(this, "_onClickEvent", _event => {
      if (this.toggle) {
        this.selected = !this.selected;
        this.changeEvent.emit(this.selected);
      }

      this.submitEvent.emit();
    });
  }

  render() {
    return html`
      <div class="flexbox">
        ${this.iconPosition === 'append' ? this.renderIcon() : nothing}
        <div id="compatibility-slot" class="${classMap({
      slotwrapper: true,
      empty: this.isempty
    })}">
          <slot @slotchange="${this.slotchanged}"></slot>
        </div>
        ${this.iconPosition === 'prepend' ? this.renderIcon() : nothing}
      </div>
    `;
  }

  componentConnected() {
    this.addEventListener('keydown', this._onKeydownEvent);
    this.addEventListener('keyup', this._onKeyupEvent);

    if (!isTouch) {
      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);
    }

    this._disabledChangeHandler(this.disabled, this.disabled);

    this.addEventListener('click', this._onClickEvent);
  }

  componentDisconnected() {
    this.removeEventListener('keydown', this._onKeydownEvent);
    this.removeEventListener('keyup', this._onKeyupEvent);

    if (!isTouch) {
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);
    }

    this.removeEventListener('click', this._onClickEvent);
  }

  componentFirstRender() {
    this.slotchanged();

    if (window.ShadyDOM) {
      // tslint:disable-line
      // workaround for shadydom (in ie and old edge)
      // otherwise we'll also get mutation updates in the shadowdom (which we don't want)
      this._mutationObeserverParent = this.shadowRoot.querySelector('#compatibility-slot');
    }

    this._mutationObserver.observe(this._mutationObeserverParent, {
      attributes: false,
      subtree: true,
      childList: true,
      characterData: true
    });
  }
  /**
   * Computes whether this button is empty or not
   */


  _getIsEmpty() {
    if (this.textContent.trim().length > 0) {
      // DAVIBE-519: if the button text is not blank the button is not empty
      return false;
    } // DAVIBE-627: check that the slot-element is also empty; any non-text-node is treated as non-empty


    const slot = this.shadowRoot.querySelectorAll('slot')[0];
    const assignedNodes = slot.assignedNodes({
      flatten: true
    });
    return assignedNodes.every(assignedNode => assignedNode.nodeName === '#text' && assignedNode.textContent.trim().length === 0);
  }

  /* Fixes the API change on the type names */
  typeIntereptor(_oldvalue, newValue) {
    switch (newValue) {
      case 'primary-alt':
        return 'neutral';

      case 'bare-alt':
        return 'bare-neutral';

      case 'outline-alt':
        return 'outline-neutral';

      case 'neutral-alt':
        {
          return 'outline';
        }

      case 'secondary-alt':
        {
          return 'outline-alt';
        }

      case 'tertiary':
        {
          return 'accent';
        }

      default:
        {
          return newValue;
        }
    }
  }

  renderIcon() {
    if (!!this.iconSrc) {
      return html`<davinci-icon-ref src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (!!this.icon) {
      return html`<davinci-icon icon=${this.icon}></davinci-icon>`;
    }

    return nothing;
  }

  _onMouseEnter() {
    this.classList.add('entered');
  }

  _onMouseLeave() {
    this.classList.remove('entered');
  }

  _disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (newValue) {
        this.tabIndex = -1;
        this.setAttribute('tabindex', '-1'); // not focussable anymore
      } else {
        this.tabIndex = 0;
        this.setAttribute('tabindex', '0');
      }
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'primary';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "iconPosition", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'append';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "toggle", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "isempty", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "changeEvent", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "submitEvent", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "typeIntereptor", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "typeIntereptor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_disabledChangeHandler", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "_disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
